<template>
  <!-- 弹窗 -->
  <div v-show="show == true">
    <div class="dialog outter-dialog common-dialog fadeInUp animated ">
      <div class="warp">
        <div class="close">
          <i
            @click="handleClose"
            v-if="closeAble"
            class="icon-cross"
          ></i>
        </div>
        <div class="content">
          <slot name="content"></slot>
        </div>
      </div>
    </div>
    <div class="mask rule-mask "></div>
  </div>
</template>
<script>
import { imageMixin } from "@/mixins";
export default {
  name: "wsDialog",
  mixins: [imageMixin],
  props: {
    show: {
      type: Boolean,
      default: false
    },
    closeAfterContent: {
      type: Boolean,
      default: false
    },
    closeAble: {
      type: Boolean,
      default: false
    },
    beforeClose: Function
  },
  methods: {
    handleClose() {
      console.log(typeof this.beforeClose )
      if (!this.closeAfterContent) {
        if (typeof this.beforeClose === "function") {
          this.beforeClose(this.hide);
        } else {
          this.hide();
        }
      } else {
        this.hide();
      }
    },
    // 点击遮罩关闭
    hide() {
      this.$emit("update:show", false);
    }
  }
};
</script>
<style lang="scss" scoped>
.warp {
  max-height: 80%;
  position: relative;
  color: #fff;
  .close {
    .icon-cross {
      position: absolute;
      z-index: 2;
      top: 0;
      //   background: url("../../assets/img/dialogClose.png") no-repeat;
      background-repeat: no-repeat;
      @include res-size(
        $left: -90px,
        $width: 65px,
        $height: 65px,
        $background-size: 65px
      );
    }
  }
   .can-scoll-y{
      width: 100%;
      height: 100%;
      word-break: break-word;
      overflow-x: hidden;
      overflow-y: auto;
    }
  .content {
    // background: url("../../assets/img/dialogBg.png") no-repeat;
    background-repeat: no-repeat;
    position: relative;
    background-size: 100% 100%;
    // background-position-x: center;
    // background-size: contain;
    //         display: flex;
    // align-items: flex-end;
    // justify-content: center;
  
    @include res-size(
      $padding:45px,
      $font-size:26px,
      $width: 895px,
      $height: 530px
    );
    /deep/ * {
      font-style: normal !important;
      font-family: inherit !important
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/wsDialog/index.vue